import { cx } from '@/lib/cx';
import styles from './VipCrown.module.css';

export interface VipCrownProps {
  size?: number;
  className?: string;
}

/** Corona del destino VIP (Cancun). Decorativa: el texto "VIP" va aparte. */
export function VipCrown({ size = 34, className }: VipCrownProps) {
  return (
    <svg
      className={cx(styles.crown, className)}
      viewBox="0 0 48 32"
      width={size}
      height={(size * 32) / 48}
      aria-hidden="true"
      focusable="false"
    >
      <path className={styles.body} d="M6 26h36l2.4-18-10.8 6.8L24 4 14.4 14.8 3.6 8Z" />
      <circle className={styles.gem} cx="24" cy="2.6" r="2.2" />
      <circle className={styles.gem} cx="3.6" cy="7.2" r="1.8" />
      <circle className={styles.gem} cx="44.4" cy="7.2" r="1.8" />
    </svg>
  );
}
